import React, { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";

import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/auth/AuthContext";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AuthModal from "@/components/AuthModal";
import SettingsModal from "@/components/SettingsModal";
import ProtectedRoute from "@/components/ProtectedRoute";

import LandingPage from "@/pages/LandingPage";
import DashboardRouter from "@/pages/DashboardRouter";
import NewProject from "@/pages/NewProject";
import AdminPortfolioEditor from "@/pages/AdminPortfolioEditor";
import ResetPassword from "@/pages/ResetPassword";
import LegalPage from "@/pages/LegalPage";

function AppShell() {
  const [authOpen, setAuthOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header onOpenAuth={() => setAuthOpen(true)} onOpenSettings={() => setSettingsOpen(true)} />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<LandingPage onOpenAuth={() => setAuthOpen(true)} />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardRouter />
              </ProtectedRoute>
            }
          />
          {/* editor de proyecto a pagina completa (id o "new") */}
          <Route
            path="/dashboard/portfolio/:id"
            element={
              <ProtectedRoute>
                <AdminPortfolioEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/nuevo-proyecto"
            element={
              <ProtectedRoute>
                <NewProject />
              </ProtectedRoute>
            }
          />
          <Route
            path="/new-project"
            element={
              <ProtectedRoute>
                <NewProject />
              </ProtectedRoute>
            }
          />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/privacy" element={<LegalPage kind="privacy" />} />
          <Route path="/terms" element={<LegalPage kind="terms" />} />
          <Route path="*" element={<LandingPage onOpenAuth={() => setAuthOpen(true)} />} />
        </Routes>
      </div>
      <Footer />
      <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} />
      <SettingsModal open={settingsOpen} onClose={() => setSettingsOpen(false)} />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppShell />
        </AuthProvider>
      </BrowserRouter>
    </LanguageProvider>
  );
}
